var _rect, _rect2, _rect3, _rect4, _g, _g2, _rect5, _rect6, _path, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyArticleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 246,
    viewBox: "0 0 235 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22,
    width: 188,
    height: 174,
    rx: 12,
    fill: "#4C637B",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 28,
    width: 176,
    height: 162,
    rx: 8,
    fill: "#071A2B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 136,
    width: 144,
    height: 38,
    rx: 4,
    fill: "#3B57E9",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 92,
    width: 144,
    height: 38,
    rx: 4,
    fill: "#3B57E9",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.371 113.5H94.9612L93.2946 117.667H91.4995L96.8328 104.333H98.4995L103.833 117.667H102.038L100.371 113.5ZM99.7044 111.833L97.6662 106.738L95.6279 111.833H99.7044ZM108.5 111.446V111H110.166V117.667H108.5V117.221C108.009 117.504 107.44 117.667 106.833 117.667C104.992 117.667 103.5 116.174 103.5 114.333C103.5 112.492 104.992 111 106.833 111C107.44 111 108.009 111.162 108.5 111.446ZM106.833 116C107.753 116 108.5 115.254 108.5 114.333C108.5 113.413 107.753 112.667 106.833 112.667C105.912 112.667 105.166 113.413 105.166 114.333C105.166 115.254 105.912 116 106.833 116Z",
    fill: "#768CFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 155L106.286 159.714L105.107 158.535L108.643 155L105.107 151.464L106.286 150.286L111 155ZM93.357 155L96.8926 158.535L95.714 159.714L91 155L95.714 150.286L96.8926 151.464L93.357 155ZM99.157 162.5H97.3834L102.843 147.5H104.617L99.157 162.5Z",
    fill: "#768CFF"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 44.75,
    width: 142.5,
    height: 36.5,
    rx: 3.25,
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 48,
    width: 144,
    height: 38,
    rx: 4,
    fill: "#3B57E9",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.833 69.6666H100.167V63.8333H94.3332V69.6666H92.6665V56.3333H94.3332V62.1666H100.167V56.3333H101.833V69.6666ZM108.5 59.6666V69.6666H106.834L106.833 61.5033L105.167 61.9499V60.2249L107.25 59.6666H108.5Z",
    fill: "#768CFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1487_150687)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 138,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#071A2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 146.75,
    width: 62.5,
    height: 62.5,
    rx: 31.25,
    fill: "#142433",
    stroke: "#768CFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5 176.5V167.5H178.5V176.5H187.5V179.5H178.5V188.5H175.5V179.5H166.5V176.5H175.5Z",
    fill: "#768CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1487_150687",
    x: 119,
    y: 130,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1487_150687"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1487_150687",
    result: "effect2_dropShadow_1487_150687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1487_150687",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyArticleDark);
export default __webpack_public_path__ + "static/media/empty-article-dark.1d84aec3b5fdb16e577abd4455cdbce4.svg";
export { ForwardRef as ReactComponent };